import React, { Component } from 'react'

import {connect} from "react-redux";
import AutoclaveCiclosMainView from "./AutoclaveCiclosMainView";
import {getAutoclaveCiclos} from "../../../actions/autoclaveActions";

const NA = 'N/A'

class AutoclaveCiclos extends Component {
    constructor(props) {
        super(props)

        if (props.ordemServicoId) {
           // props.getServiceOrderDetail(props.serviceOrderId);
        }
    }

    componentDidMount(){
        this.props.getAutoclaveCiclos();
    }


    render() {
        const { AutoclaveCiclos } = this.props.autoclaves;

        console.log("AutoclaveCiclos", AutoclaveCiclos);

        return (
            <AutoclaveCiclosMainView
                ciclos={AutoclaveCiclos}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        autoclaves: state.autoclaves
    }
}

export default connect(mapStateToProps, { getAutoclaveCiclos  })(AutoclaveCiclos);
